<template>
  <ScreenAdapter>
    <div id="main">
      <Header />
      <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div>
      <Nav />
      <div class="eol-main-container">
        <div class="power-content" ref="193">
          <div class="content-header">
            <div class="text">强国建设</div>
          </div>
          <div class="content-box">
            <div class="current-cat">
              <template v-for="item,index in powerCat">
                <!-- 不展示课程"VR" -->
                <div v-if="item.name !='VR'" :class="['cat-item',catId_1==item.id?'active':'']" :key="index" @click="currentCat(item,'1')">{{ item.name }}</div>
              </template>
            </div>
            <div class="swiper-content">
              <swiper :options="swiperOption_1" v-if="powerData&&powerData.length>0">
                <swiper-slide :data-id="item.id" :style="`background:url('${item.photo}') no-repeat center/cover;`" v-for="item in powerData" :key="item.id">
                </swiper-slide>
              </swiper>
              <div v-show="powerData&&powerData.length>6">
                <div class="p swiper-pagination"></div>
                <div class="p swiper-button-next"></div>
                <div class="p swiper-button-prev"></div>
              </div>

            </div>
          </div>
        </div>

        <a target="_blank" :href="course_cover_info.url" class="course-banner" :style="`background:url(${course_cover_info.cover}) no-repeat center/cover`"></a>

        <div class="beauty-content" ref="194">
          <div class="content-header">
            <div class="text">美丽中国</div>
          </div>
          <div class="content-box">
            <div class="current-cat">
              <div :class="['cat-item',catId_2==item.id?'active':'']" v-for="item,index in beautyCat" :key="index" @click="currentCat(item,'2')">{{ item.name }}</div>
            </div>
            <div class="b swiper-content">
              <swiper :key="'swiper_2'+beautyData[0].id" :slides-per-view="0" :options="swiperOption_2" v-if="beautyData&&beautyData.length>0">
                <swiper-slide :style="`background:url('${item.photo}') no-repeat center/cover;`" v-for="item in beautyData" :key="item.id" :data-id="item.id">
                </swiper-slide>
              </swiper>

              <div v-show="beautyData&&beautyData.length>3">
                <div class="b swiper-pagination"></div>
                <div class="b swiper-button-next"></div>
                <div class="b swiper-button-prev"></div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </ScreenAdapter>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../../config/services'
import ScreenAdapter from "@/components/ScreenAdapter.vue"
export default {
  data () {
    let that = this
    return {
      cover: require("../../../assets/hzvtc/cover/feelings.png"),
      course_cover_info: {
        cover: require("../../../assets/hzvtc/cover/banner-power.png"), // 强国建设VR系列资源
        url: `${services.XUEXI_HOST}/center/100028/hzvtc/detail?id=340&key=feelings`
      },
      school_code: localStorage.getItem("schoolCode"),
      powerData: [], // 强国建设
      beautyData: [],  // 美丽中国
      powerCat: [], // 强国建设下级分类
      beautyCat: [], // 美丽中国下级分类
      catId_1: "",
      catId_2: "",
      swiperOption_1: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        slidesPerGroup: 6,
        slidesPerColumnFill: 'row',
        observer: true,
        observeParents: true,
        pagination: {
          el: ".p.swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".p.swiper-button-next",
          prevEl: ".p.swiper-button-prev",
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-id");
            if (id) {
              window.open(`/center/${that.school_code}/hzvtc/detail?id=${id}&key=feelings`, "_blank")
            }

          },
        },
      },
      swiperOption_2: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 19,
        pagination: {
          el: ".b.swiper-pagination",
          clickable: true,
        },
        observer: true,
        observeParents: true,
        // loop: true,
        autoplay: {
          delay: 12000
        },
        navigation: {
          nextEl: ".b.swiper-button-next",
          prevEl: ".b.swiper-button-prev",
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-id");
            if (id) {
              window.open(`/center/${that.school_code}/hzvtc/detail?id=${id}&key=feelings`, "_blank")
            }

          },
        },
      },
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  async mounted () {
    await this.getCatData()
    await this.getListData("1,2")
  },
  methods: {
    // 切换分类
    currentCat (val, flag) {
      this[`catId_${flag}`] = val.id
      this.getListData(flag)
    },
    async getCatData () {
      // 强国建设二级分类
      await services.getCategoryList({ root_id: "193", school_code: this.school_code }).then(res => {
        this.powerCat = [
          {
            "id": 123,
            "name": "科技强国",
            "root_id": 193,
            "path": "121-193-",
            "level": 3
          },
          {
            "id": 132,
            "name": "制造强国",
            "root_id": 193,
            "path": "121-193-",
            "level": 3
          },

          {
            "id": 122,
            "name": "农业强国",
            "root_id": 193,
            "path": "121-193-",
            "level": 3
          },
          {
            "id": 138,
            "name": "法治强国",
            "root_id": 193,
            "path": "121-193-",
            "level": 3
          },

          {
            "id": 124,
            "name": "强国有浙",
            "root_id": 193,
            "path": "121-193-",
            "level": 3
          },
          {
            "id": 131,
            "name": "习近平在浙江",
            "root_id": 193,
            "path": "121-193-",
            "level": 3
          },


        ]
        this.catId_1 = this.powerCat[0].id
      })

      // 美丽中国二级分类
      await services.getCategoryList({ root_id: "194", school_code: this.school_code }).then(res => {
        this.beautyCat = res.data
        this.catId_2 = res.data[0].id
      })

    },
    // 请求列表数据
    async getListData (val) {
      // 根据选中的id请求swiper数据
      // 强国建设
      if (val.indexOf("1") > -1) {
        await services.getCourseList({ page: 1, size: 100, category_id: this.catId_1, school_code: this.school_code }).then(res => {
          this.powerData = res.data.items
        })
      }
      // 美丽中国
      if (val.indexOf("2") > -1) {
        await services.getCourseList({ page: 1, size: 100, category_id: this.catId_2, school_code: this.school_code }).then(res => {
          this.beautyData = res.data.items
          if (this.$refs.swiper_2) {
            this.$refs.swiper_2.swiper.resize.resizeHandler()
          }
        })
      }

      if (val.indexOf("1,2") > -1) {
        await this.jumpPosition()
      }

    },
    // 跳转到详情
    jumpDetail (item) {
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=feelings`, "_blank")
    },

    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          let element = document.getElementsByClassName("outContainer")[0]
          element.scrollTop = topVal - 100
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  width: 100%;
  height: 510px;
}

.eol-main-container {
  width: 1200px;
  margin: 0 auto;
  .content-header {
    width: 100%;
    height: 42px;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before,
    &::after {
      content: '';
      display: inline-block;
      width: 172px;
      height: 26px;
      position: absolute;
      top: 50%;
      background: url('../../../assets/hzvtc/common/list-ttile.png') no-repeat 0 /
        cover;
      transform: translateY(-40%);
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
    .text {
      font-size: 42px;
      font-weight: bold;
      background: linear-gradient(180deg, #b70000 70%, #ffcba5 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .power-content {
    .content-header {
      margin: 50px 0 25px;
      &::before,
      &::after {
        width: 450px;
      }
    }
    .content-box {
      display: flex;
      justify-content: space-between;
      .current-cat {
        width: 259px;
        flex-shrink: 0;
        .cat-item {
          width: 100%;
          height: 70px;
          background: #ffeada;
          text-align: center;
          line-height: 70px;
          font-weight: bold;
          color: #b61e2a;
          transition: all 0.3s;
          font-size: 20px;
          z-index: 1;
          cursor: pointer;
          &.active,
          &:hover {
            color: #ffffff;
            position: relative;
            &::before {
              content: '';
              display: inline-block;
              background: url('../../../assets/hzvtc/list/fellings-cur-active.png')
                no-repeat center/cover;
              position: absolute;
              left: 0;
              top: 0;
              height: 100%;
              width: 276px;
              z-index: -1;
            }
          }
        }
      }
      .swiper-content {
        width: 942px;
        background: #fff6ee;
        padding: 30px 40px 0;
        position: relative;
        .swiper-slide {
          cursor: pointer;
          width: 257px !important;
          height: 145px !important;
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          margin: 0 15px 24px !important;
        }
        .swiper-container {
          width: 100%;
          height: 100%;
        }
        ::v-deep .swiper-wrapper {
          height: 0;
          transition-duration: 300ms !important;
        }

        ::v-deep .swiper-pagination {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          bottom: 27px;
          left: 50%;
          transform: translateX(-50%);
        }
        ::v-deep .swiper-pagination-bullet {
          border-radius: 50%;
          display: block;
          transition: all 0.3s;
          margin-right: 6px;
          width: 8px;
          height: 8px;
          background: #ffbe8f;
        }

        ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
          background: #b70000;
        }

        .swiper-button-next,
        .swiper-button-prev {
          flex-shrink: 0;
          background-size: cover;
          z-index: 100;
          position: absolute;
          transform: translateY(-50%);
          cursor: pointer;
          width: 40px;
          height: 40px;
          bottom: -6.5px;
        }
        .swiper-button-prev {
          left: 245px;
          background: url('../../../assets/hzvtc/list/value-prev.png') no-repeat
            center/cover;
        }
        .swiper-button-next {
          right: 245px;
          background: url('../../../assets/hzvtc/list/value-next.png') no-repeat
            center/cover;
        }
      }
    }
  }
  .beauty-content {
    margin: 0 0 50px;
    .content-header {
      margin: 80px 0 35px;
      &::before,
      &::after {
        width: 450px;
      }
    }
    .content-box {
      .current-cat {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 45px;
        border-radius: 69px 69px 69px 69px;
        border: 2px solid #b70000;
        .cat-item {
          flex: 1;
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          height: 100%;
          line-height: 41px;
          border-radius: 0;
          cursor: pointer;
          &.active {
            color: #ffffff;
            background: #b61e2a;
            &:first-child {
              border-radius: 69px 0 0 69px;
            }
            &:last-child {
              border-radius: 0 69px 69px 0;
            }
          }
        }
      }
      .swiper-content {
        width: calc(1035px - 19px);
        margin: 0 auto;
        height: 250px;
        position: relative;
        padding: 36px 0 0;
        .swiper-slide {
          width: 327px !important;
          height: 184px !important;
          cursor: pointer;
        }

        ::v-deep .swiper-pagination {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
        }
        ::v-deep .swiper-pagination-bullet {
          border-radius: 50%;
          display: block;
          transition: all 0.3s;
          margin-right: 6px;
          width: 8px;
          height: 8px;
          background: #ffbe8f;
        }

        ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
          background: #b70000;
        }

        .swiper-button-next,
        .swiper-button-prev {
          flex-shrink: 0;
          background-size: cover;
          z-index: 100;
          position: absolute;
          transform: translateY(-50%);
          cursor: pointer;
          width: 28px;
          height: 126px;
          top: 50%;
        }
        .swiper-button-prev {
          left: -52px;
          background: url('../../../assets/hzvtc/list/beauty-prev.png')
            no-repeat center/cover;
        }
        .swiper-button-next {
          right: -52px;
          background: url('../../../assets/hzvtc/list/beauty-next.png')
            no-repeat center/cover;
        }
      }
    }
  }
}
.course-banner {
  display: block;
  width: 100%;
  height: 90px;
  margin: 30px 0 0;
  position: relative;
  z-index: 100;
}
</style>